import {
  addDoc,
  collection,
  deleteDoc,
  doc,
  getDoc,
  getDocs,
  orderBy,
  query,
  updateDoc,
  where,
} from "firebase/firestore";
import { db } from "../firebase";
import { ReplyButton } from "../model/ReplyButton";
import { CreateState, SystemParameter00000001, UserCardCreateState } from "../model/Systemparameters";

const systemParametersId = "00000001";

const systemParametersQuery = {
  // 運営側返信ボタン一覧取得
  getReplyButtons: async () => {
    console.log("systemParameters getReplyButtons access");
    const replyButtonsRef = await getDocs(collection(db, `systemParameters/${systemParametersId}/replyButtons`));
    return replyButtonsRef.docs.map((item) => item.data() as ReplyButton)
  },
  // 運営側返信ボタン作成
  setReplyButton: async (replyButton: ReplyButton): Promise<void> => {
    console.log("systemParameters setReplyButtons access");
    try {
      const resolve = await addDoc(
        collection(db, `systemParameters/${systemParametersId}/replyButtons`),
        replyButton);
      await updateDoc(resolve, {id: resolve.id});
    } catch (err: any) {
      console.error(err);
    }
  },
  // 運営側返信ボタン更新
  updateReplyButton: async (replyButton: ReplyButton): Promise<void> => {
    console.log("systemParameters updateReplyButtons access");
    try {
      await updateDoc(
        doc(db, `systemParameters/${systemParametersId}/replyButtons/${replyButton.id}`),
        replyButton);
    } catch (err: any) {
      console.error(err);
    }
  },
  // 運営側返信ボタン削除
  deleteReplyButton: async (documentId: string): Promise<void> => {
    console.log("systemParameters deleteReplyButton access");
    try {
      await deleteDoc(doc(db, `systemParameters/${systemParametersId}/replyButtons/${documentId}`));
    } catch (err: any) {
      console.error(err);
    }
  },
  // 団体に紐づく未完了の利用者作成ステート一覧取得
  getCreateState: async (tenantId: string): Promise<any | CreateState> => {
    console.log('systemParameters getCreateState access');
      const docsRef = await getDocs(
        query(
          collection(db, 'systemParameters/00000001/createState'),
          where('tenantId', '==', tenantId),
          where("status", "!=", "completion")
        )
      );
      return docsRef.docs.map((doc) => doc.data()).at(0) as CreateState;
  },

  // オプション契約の取得
  getOptionContract: async (): Promise<SystemParameter00000001 | any> => {
    console.log('systemParameters getOptionContract access');
    const docRef = await getDoc(doc(db, "systemParameters", systemParametersId));
    const config = docRef.data() as SystemParameter00000001;
    return config.optionContract;
  },

  // 各団体の利用者IDカード一覧の取得
  getUserIdCardCreatList: async (tenantId: string): Promise<UserCardCreateState[]> => {
    console.log('systemParameters getUserIdCardCreatList access');
    const docsRef = await getDocs(
      query(
        collection(db, `systemParameters/${systemParametersId}/userCardCreateState`),
        where('tenantId', '==', tenantId)
      )
    );
    return docsRef.docs.map((doc) => doc.data() as UserCardCreateState);
  },
  // 利用者IDカード更新
  updateUserIdCardCreat: async (userIdCardData: UserCardCreateState): Promise<void> => {
    console.log("systemParameters updateUserIdCardCreat access");
    await updateDoc(
      doc(db, `systemParameters/${systemParametersId}/userCardCreateState/${userIdCardData.id}`),
      userIdCardData);
  },
  // ジョインのURLを取得
  getMachitappuURL: async (): Promise<SystemParameter00000001 | any> => {
    console.log('systemParameters getMachitappuURL access');
    const docRef = await getDoc(doc(db, "systemParameters", systemParametersId));
    const config = docRef.data() as SystemParameter00000001;
    return config.machitappuUrl;
  },
}
export default systemParametersQuery;